import { Admin, Resource } from 'react-admin';
import { authProvider, dataProvider } from './authProvider';
import { UserList } from './resources/components/users/UserList';
import { UserShow } from './resources/components/users/UserShow';
import { UserEdit } from './resources/components/users/UserEdit';
import { SettingsList } from './resources/components/settings/SettingsList';
import { SettingsEdit } from './resources/components/settings/SettingsEdit';
import { CountryCpmList } from './resources/components/country_cpm_floors/CountryCpmList';
import { CountryCpmEdit } from './resources/components/country_cpm_floors/CountryCpmEdit';
import { darkTheme } from './theme';
//import { LoginPage } from './resources/components/LoginPage';
import { CustomLayout } from './resources/components/CustomLayout';
import { Dashboard } from './resources/components/Dashboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGear, faGlobe, faUsers } from '@fortawesome/free-solid-svg-icons'

const UsersIcon = () => <FontAwesomeIcon icon={faUsers} size="lg" />;
const GlobeIcon = () => <FontAwesomeIcon icon={faGlobe} size="lg" />;
const GearIcon = () => <FontAwesomeIcon icon={faGear} size="lg" />;

function App() {
    return (
        <Admin
        authProvider={authProvider}
        dataProvider={dataProvider}
        title="Ad Loot Admin"
        //loginPage={LoginPage}
        layout={CustomLayout}
        theme={darkTheme}
        dashboard={Dashboard}
        >
        <Resource 
            name="users" 
            list={UserList} 
            show={UserShow} 
            edit={UserEdit}
            icon={UsersIcon}
            options={{ label: 'Users' }}  
        />
        <Resource
            name="country_cpm_floors"
            list={CountryCpmList}
            edit={CountryCpmEdit}
            icon={GlobeIcon}
            options={{ label: 'Countries' }}
        />
        <Resource
            name="settings"
            list={SettingsList}
            edit={SettingsEdit}
            icon={GearIcon}
            options={{ label: 'Settings' }}
        />
        </Admin>
    );
}

export default App;